import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SiteNavAMobileFlyout from 'components/SiteNav/SiteNavA/SiteNavAMobile/SiteNavAMobileFlyout';
import SiteNavAMobileLevelA from 'components/SiteNav/SiteNavA/SiteNavAMobile/SiteNavAMobileLevelA';
import SiteNavAMobileLevelC from 'components/SiteNav/SiteNavA/SiteNavAMobile/SiteNavAMobileLevelC';

class SiteNavAMobileContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      levelCVisible: false,
      flyoutVisible: false,
    };

    this.handleHamburgerClick = this.handleHamburgerClick.bind(this);
    this.handleXClick = this.handleXClick.bind(this);
    this.handleFlyoutItemClick = this.handleFlyoutItemClick.bind(this);
    this.handleLevelCHeadingClick = this.handleLevelCHeadingClick.bind(this);
    this.handleLevelCItemClick = this.handleLevelCItemClick.bind(this);
  }

  handleHamburgerClick() {
    const { flyoutVisible } = this.state;
    this.setState({ flyoutVisible: !flyoutVisible });
  }

  handleXClick() {
    this.setState({ flyoutVisible: false });
  }

  handleFlyoutItemClick() {
    this.setState({ flyoutVisible: false });
  }

  handleLevelCHeadingClick() {
    const { levelCVisible } = this.state;
    this.setState({ activeLevelCItem: '' });
    this.setState({ levelCVisible: !levelCVisible });
  }

  handleLevelCItemClick(id) {
    let value = id;
    const { activeLevelCItem } = this.state;
    if (activeLevelCItem === id) {
      value = '';
    }
    this.setState({ activeLevelCItem: value });
  }

  renderLevelC() {
    const {
      levelBSelected = {},
      levelCItems,
      selectedItem,
    } = this.props;
    const { levelCVisible, activeLevelCItem } = this.state;

    if (!levelBSelected.heading || !levelBSelected.isVisible) {
      return null;
    }

    return (
      <SiteNavAMobileLevelC
        items={levelCItems}
        heading={levelBSelected.heading}
        href={levelBSelected.href}
        subHeading={selectedItem.heading}
        levelCVisible={levelCVisible}
        onLevelCHeadingClick={this.handleLevelCHeadingClick}
        onLevelCItemClick={this.handleLevelCItemClick}
        activeLevelCItem={activeLevelCItem}
      />
    );
  }

  render() {
    const {
      items = [],
      imageUrl,
      imageLinkHref,
      contactHref,
      siteId,
      searchResultsLinkHref,
      itemsCount,
      cartUrl,
    } = this.props;
    const { flyoutVisible } = this.state;

    return (
      <div>
        <SiteNavAMobileFlyout
          {...this.props}
          items={items}
          isVisible={flyoutVisible}
          onXClick={this.handleXClick}
          onItemClick={this.handleFlyoutItemClick}
          onOverlayClick={this.handleXClick}
        />

        <SiteNavAMobileLevelA
          imageUrl={imageUrl}
          imageLinkHref={imageLinkHref}
          onHamburgerClick={this.handleHamburgerClick}
          contactHref={contactHref}
          siteId={siteId}
          searchResultsLinkHref={searchResultsLinkHref}
          itemsCount={itemsCount}
          cartUrl={cartUrl}
        />
        {this.renderLevelC()}
      </div>
    );
  }
}

SiteNavAMobileContainer.propTypes = {
  items: PropTypes.array.isRequired,
  imageUrl: PropTypes.string,
  imageLinkHref: PropTypes.string,
  contactHref: PropTypes.string,
  levelBSelected: PropTypes.object,
  levelCItems: PropTypes.array,
  levelCSelected: PropTypes.object,
  selectedItem: PropTypes.object,
  siteId: PropTypes.string,
  searchResultsLinkHref: PropTypes.string,
  itemsCount: PropTypes.number,
  cartUrl: PropTypes.string,
};

export default SiteNavAMobileContainer;
